import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import { UrlResponse, ExportData } from "types/apiTypes";
import { RequestMethods } from "types/enums";

export const exportsApi = createApi({
  reducerPath: "exportsApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    exportData: builder.mutation<UrlResponse, ExportData>({
      query: (body) => ({
        url: "/exports",
        method: RequestMethods.POST,
        body,
      }),
    }),
    exportUserData: builder.mutation<string, void>({
      query: () => ({
        url: "/exports/download_users_data",
        method: RequestMethods.GET,
        responseHandler: (res) => res.text()
      }),
    }),
  }),
});

export const { useExportDataMutation, useExportUserDataMutation } = exportsApi;
